import { getAlpha2WithExceptions } from '@/components/Checkout/_helpers/functions/getAlpha2WithExceptions'
import type { GlobalStoreValues } from '@/store/useGlobalStore'
import { sendGTMEvent } from '@next/third-parties/google'

type Props = {
  globalStore: GlobalStoreValues
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getGACookieValue = () => {
  const gaCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_ga='))
  if (gaCookie) {
    const gaValue = gaCookie.split('=')[1] // Get the value part of the cookie
    const clientId = gaValue.split('.').slice(-2).join('.') // Extract the last two parts

    return clientId
  }
  return null
}

export const gmtSetParameters = ({ globalStore }: Props) => {
  const {
    app: { alpha2, language },
    user: { customer, refID, isSignedIn, customerType },
    loaders: { isLoadingSigningOut },
  } = globalStore

  if (isLoadingSigningOut) {
    return
  }

  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'set_parameters',
    event_id: uuid,
    user_market: getAlpha2WithExceptions({ alpha2 }),
    user_market_extended: alpha2,
    user_language: language,
    client_id: '1234567890.0987654321', // data from _ga cookie
    userID: isSignedIn ? customer?.id.unicity : undefined,
    email: isSignedIn ? customer?.email : undefined,
    first_name: isSignedIn ? customer?.humanName.firstName : undefined,
    last_name: isSignedIn ? customer?.humanName.lastName : undefined,
    referral_code: isSignedIn ? refID || undefined : undefined,
    enroller_id: isSignedIn ? customer?.enroller.id.unicity : undefined,
    membership_registration_date: isSignedIn ? customer?.joinDate : undefined,
    user_type: customerType,
    is_user_logged_in: isSignedIn ? 'true' : 'false',
  })
}
